import r from "./de.json.mjs";
import o from "./en.json.mjs";
import m from "./es.json.mjs";
import t from "./fr.json.mjs";
import i from "./it.json.mjs";
import p from "./ja.json.mjs";
import f from "./ko.json.mjs";
import e from "./nl.json.mjs";
import s from "./pt.json.mjs";
import a from "./tr.json.mjs";
import l from "./vi.json.mjs";
import v from "./zh.json.mjs";
import d from "./pl.json.mjs";
import n from "./sv.json.mjs";
var B = {
  de: r,
  en: o,
  es: m,
  fr: t,
  it: i,
  ja: p,
  ko: f,
  nl: e,
  pt: s,
  tr: a,
  vi: l,
  zh: v,
  pl: d,
  sv: n
};
export {
  B as localizedMessages
};
